import { Quote } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import Reveal from "@/components/Reveal";

/**
 * Testimonials section. Reviews are only rendered when provided — we never
 * publish placeholder/fake reviews. To go live, add entries to `REVIEWS`.
 */
export const REVIEWS = [];

export default function Testimonials() {
  if (!REVIEWS.length) {
    return (
      <section className="container-x py-20 sm:py-28" aria-labelledby="reviews-h" data-testid="testimonials">
        <SectionHeading
          eyebrow="Reviews"
          title="Kind Words, Coming Soon"
          subtitle="We're gathering feedback from our first clients. Real reviews will appear here as we receive them."
          as="h2"
          align="center"
        />
        <Reveal className="mt-12 mx-auto max-w-xl">
          <div className="border border-dashed border-rose/40 bg-blush-soft/40 px-8 py-12 text-center">
            <Quote size={30} strokeWidth={1.25} className="mx-auto text-rose" aria-hidden="true" />
            <p className="mt-4 text-ink/70 leading-relaxed">
              Worked with us recently? We'd love your feedback — call or text and
              we'll share where to leave a review.
            </p>
          </div>
        </Reveal>
      </section>
    );
  }

  return (
    <section className="container-x py-20 sm:py-28" aria-labelledby="reviews-h" data-testid="testimonials">
      <SectionHeading eyebrow="Reviews" title="What Our Clients Say" as="h2" align="center" />
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <figure className="h-full bg-white border border-gold/20 p-8">
              <Quote size={24} className="text-rose" aria-hidden="true" />
              <blockquote className="mt-4 text-ink/80 leading-relaxed">{r.quote}</blockquote>
              <figcaption className="mt-5 eyebrow text-ink">{r.name}</figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
